module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer"
  }, [(_vm.item.attr === 'tempalteSelect') ? [_c('el-select', {
    attrs: {
      "disabled": _vm.item.nonEditable === 1,
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleTemp
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  }, _vm._l((_vm.item.valueArrMap), function(arr) {
    return _c('el-option', {
      key: arr.key,
      attrs: {
        "label": arr.value,
        "value": arr.key
      }
    })
  }))] : (_vm.item.attr === 'mainUser') ? [_c('v-manager', {
    attrs: {
      "item": _vm.item,
      "form": _vm.form
    }
  })] : (_vm.item.attr === 'customerName') ? [_c('associated-field', {
    ref: "associatedField",
    attrs: {
      "module": "customerApi",
      "item": _vm.item,
      "form": _vm.form
    },
    on: {
      "addNew": _vm.addNew,
      "emitObj": _vm.changeCustomer
    }
  })] : (_vm.item.attr === 'contact') ? [(_vm.form.customerName) ? _c('remote-select', {
    attrs: {
      "module": "contact",
      "customerId": _vm.form.customerName.id,
      "always": true,
      "item": _vm.item,
      "form": _vm.form
    }
  }) : _c('span', [_vm._v("无")])] : (_vm.item.attr === 'opportunity') ? [(_vm.form.customerName) ? _c('remote-select', {
    attrs: {
      "module": "opportunity",
      "moduleName": "workOrder",
      "customerId": _vm.form.customerName.id,
      "always": true,
      "item": _vm.item,
      "form": _vm.form
    }
  }) : _c('span', [_vm._v("无")])] : (_vm.item.attr === 'contract') ? [(_vm.item.nonEditable === 1) ? _c('el-input', {
    attrs: {
      "disabled": true,
      "value": _vm.item.attrValue.value || '无'
    }
  }) : (_vm.form.customerName.id) ? _c('remote-select', {
    attrs: {
      "module": "contract",
      "customerId": _vm.form.customerName.id,
      "always": true,
      "item": _vm.item,
      "form": _vm.form
    }
  }) : _c('span', [_vm._v("无")])] : (_vm.item.attr === 'phone') ? _c('v-phone', {
    attrs: {
      "attrValue": _vm.form.phone
    },
    on: {
      "numChange": _vm.phoneSave,
      "update:attrValue": function($event) {
        _vm.$set(_vm.form, "phone", $event)
      }
    }
  }) : (_vm.item.attr === 'products') ? [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "v-area"
  }, [(_vm.form[_vm.item.attr] && _vm.form[_vm.item.attr].length) ? [_vm._v(_vm._s(_vm._f("productLen")(_vm.form[_vm.item.attr])))] : [_vm._v("暂无关联产品")]], 2), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": _vm.emitParent
    }
  }, [_vm._v("选择")])])] : (_vm.item.attr === 'address') ? _c('v-address', {
    ref: "address",
    attrs: {
      "attrValue": _vm.form.address
    },
    on: {
      "change": _vm.addressSave
    }
  }) : (_vm.item.attr === 'implementingTime') ? [_c('el-date-picker', {
    class: {
      disable: _vm.item && _vm.item.nonEditable
    },
    attrs: {
      "editable": false,
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择实施时间"
    },
    model: {
      value: (_vm.form[_vm.item.attr]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.item.attr, $$v)
      },
      expression: "form[item.attr]"
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ce579c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/work-order/index.vue
// module id = 1268
// module chunks = 82